    
<mat-card class="map-container">
  <mat-card-content>
    <span class="copyright"  >
      {{mapCopyRight}}</span>
    <!-- <div class="copyright" >{{copyRight}}</div> -->
    <div class="tab-menu-wrapper">
      <div>
        <mat-tab-group animationDuration="0ms">
          <mat-tab>
            <!-- Dummy Tab to remove default Tab selection -->
          </mat-tab>
          <!-- TAB - 1:Search -->
          <mat-tab >
            <div class="tab-menu-content">
              <app-map-search 
                (sendMarkerData)="getSearchedMarkerData($event)"
              ></app-map-search>
            </div>
            <ng-template mat-tab-label>
              <mat-icon>search</mat-icon>
            </ng-template>
            <!-- Map Search  -->
            
          </mat-tab>
          <!-- TAB - 2:Map Options Dropdown -->
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>layers</mat-icon>
            </ng-template>
            <div class="tab-menu-content">
              <mat-form-field appearance="outline">
                <mat-select
                  placeholder="Map Provider"
                  [ngModel]="selectedMapLayer"
                  (ngModelChange) ="onBaseMapLayerChange($event)"
                  [compareWith]="compareWithMapProvider"
                >
                  <mat-option *ngFor="let map of mapLayersList" [value]="map">{{
                    map.name
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div class="settings">      
   <!-- Save Locally -->
      <mat-icon [ngClass]="{
        'status-loading': saveStatus === null,
        'status-success': saveStatus === 'Success',
        'status-failed': saveStatus === 'Failed'
      }"
      [matTooltip]="saveStatus === 'Success' ? 'Auto Save On' : saveStatus === 'Failed' ? 'Auto Save Off' : 'Saving...'"
        (click)="openSaveLocallyDialog()">
        save
      </mat-icon>
      &nbsp;
      <mat-icon 
              aria-hidden="false" 
              aria-label="Map Settings"
              matTooltip="Map Settings"
              (click)="openSettingsDialog()"
              >settings</mat-icon>
              &nbsp;
      <mat-icon 
              aria-hidden="false" 
              aria-label="Logout"
              matTooltip="Logout"
              (click)="logout()"
              >power_settings_new</mat-icon>
    </div>
    <!-- Render maps based on Search -->
    <div
      id="map"
      class="render-maps"
      leaflet
      (leafletClick)="getCoordinatesOnClick($event)"
      (leafletMapReady)="onMapReady($event)"
      [leafletOptions]="mapOptions"
    >
      <div [leafletLayer]="baseMapTileLayer"></div>
    </div>
     <!-- Sub Component (without view) to handle the Route related functionality -->
    <app-map-route
      [(map)] = "map"
      [currentItineraryDetails] = "currentItineraryDetails"
      [mapSettings] = "mapSettings"
      (hideRouteSummaryTemplate) = "hideRouteSummaryTemplate($event)"
      (sendNewWaypointData) ="getWaypointToBeAdded($event)"
    >
  </app-map-route>
  </mat-card-content>
</mat-card>
